import home from './src/home.vue'
import LedDeviceManagerView from './src/LedDeviceManager/LedDeviceManagerView.vue' //LED设备列表
import LedDeviceManagerEdit from './src/LedDeviceManager/LedDeviceManagerEdit.vue' //LED设备详情

import LEDMassMessageView from './src/LedMassMessage/LedMassMessageView.vue' //LED一键群发
import LEDMassMessageInfo from './src/LedMassMessage/LedMassMessageInfo.vue' //LED一键群发详细

import LEDPlanManagerView from './src/LEDPlanManagerView/LEDPlanManagerView.vue' //LED上屏

import LEDSendPlanManagerView from './src/LEDPlanManagerView/LEDSendPlanManagerView.vue'

let views = {
    home,
    LedDeviceManagerView,
    LedDeviceManagerEdit,
    LEDMassMessageView,
    LEDMassMessageInfo,
    LEDPlanManagerView,
    LEDSendPlanManagerView
};

export default views;